import { render, staticRenderFns } from "./detail-info-form.vue?vue&type=template&id=25fe4cee&scoped=true&"
import script from "./detail-info-form.vue?vue&type=script&lang=js&"
export * from "./detail-info-form.vue?vue&type=script&lang=js&"
import style0 from "./detail-info-form.vue?vue&type=style&index=0&id=25fe4cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe4cee",
  null
  
)

export default component.exports